export const BASE_URL = 'https://crunchmembertracker-3baa91eeb088.herokuapp.com'